export enum ItemSaleEditStatus {
  // AuctionTypeEnum.BuyNow (for BuyNow = AuctionTypeEnum.BuyNow class-transformer returns NaN)
  BuyNow = 'buyNow',
  // AuctionTypeEnum.PriceProposal
  PriceProposal = 'priceProposal',
  // AuctionTypeEnum.Bidding
  Bidding = 'bidding',
  Disabled = 'disabled',
}
